import { styled } from "@mui/system";

export const Wrapper = styled("div")`
  width: 100%;

  .react-datepicker-wrapper {
    width: 100% !important;
    max-width: none !important;
  }

  .react-datepicker__input-container {
    width: 100%;
  }
`;
